/** ฝ่ามือก้องระฆัง (lane C4 skeleton): gold + brown, motif chips. Built from swordKit via families/handArtGen.ts; polish later. */
import { makeHandArt } from '../families/handArtGen';

export const PRAJNAPALM_FX: ReturnType<typeof makeHandArt> = makeHandArt('hum-palm', { a: 'gold', b: 'brown', motif: 'chips' }, [
  ['pp-shatter', 'fist'],
  ['pp-thousand', 'palm', 2],
  ['pp-calm', 'palm', 3],
  ['pp-dharma', 'ring', 5],
  ['pp-lotus', 'heal'],
  ['pp-vow', 'buff'],
  ['pp-tathagata', 'power', 3.5],
]);
